<template>
  <div>
    <b-modal 
      id="th-image-modal" 
      ref="th-image-modal-ref" 
      hide-footer title="The Places You Will Visit"
    >
      <div class="p-3 mt-5 mb-5" :class="getPlaces().length > 4 ? 'places' : 'places-small'">
        <p
          class="m-3 place-select"
          v-for="(place, placeIndex) in getPlaces()"
          :class="activeItem === placeIndex ? 'active-place' : ''"
          @click="handleSelect(placeIndex)"
          :key="`place-title-${placeIndex}`"
        >
          {{ place.toUpperCase() }}
        </p>
      </div>
      <div class="mb-5 mt-5">
        <Slider 
          :images="images" 
          :controls="true" 
          image-size="large"
        />
      </div>
      <div class="mb-5 mt-5">
        <p v-html="description"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Slider from '../slider/index.vue'
export default {
  name: 'TouringHubImages',
  components: {
    Slider
  },
  props: {
    touringHubItem: {
      type: Object
    }
  },
  data() {
    return {
      placeImages: [],
      placeDescription: '',
      activeItemIndex: 0
    }
  },
  computed: {
    images () {
      return this.placeImages
    },
    description () {
      return this.placeDescription
    },
    activeItem () {
      return this.activeItemIndex
    }
  },
  mounted () {
    this.getPlaceData(0)
  },
  methods: {
    showModal() {
      this.$refs["th-image-modal-ref"].show();
    },
    getPlaces () {
      return this.touringHubItem.placeData.map((place) => {
        return place.content.title
      })
    },
    getPlaceData (placeIndex) {
      // Set active item
      this.activeItemIndex = placeIndex
      if( this.touringHubItem.placeData[placeIndex] === undefined) {
        return
      }
      // Get hero image
      const heroImage = this.touringHubItem.placeData[placeIndex].content.heroImage
      // Get any other images
      const otherImages = this.touringHubItem.placeData[placeIndex].content.images
      // Get description
      const description = this.touringHubItem.placeData[placeIndex].content.description
      // combine in image array
      this.placeImages = [heroImage, ...otherImages]
      // Set description
      this.placeDescription = description
    },
    handleSelect (placeIndex) {
      this.getPlaceData(placeIndex)
    }
  },
}
</script>

<style lang="scss">
.places {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: auto;
  white-space: nowrap;
}
.places-small {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  white-space: normal;
}
.place-select {
  cursor: pointer;
}
.active-place {
  font-weight: bold;
}
</style>